import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface IDismissedAlertStore {
    dismissedAlertIds: Set<number>
    dismissAlert: (id: number) => void
    clearDismissed: () => void
}

export const useDismissedAlertStore = create<IDismissedAlertStore>()(
    persist(
        (set) => ({
            dismissedAlertIds: new Set(),
            dismissAlert: (id) =>
                set((state) => {
                    const newSet = new Set(state.dismissedAlertIds)
                    newSet.add(id)
                    return { dismissedAlertIds: newSet }
                }),
            clearDismissed: () => set({ dismissedAlertIds: new Set() })
        }),
        {
            name: 'dismissed-alert-store',
            partialize: (state) => ({
                // Set은 JSON 직렬화가 안 되므로 배열로 변환해서 저장
                dismissedAlertIds: Array.from(state.dismissedAlertIds),
            }),
            onRehydrateStorage: () => (state) => {
                // 복원 시 배열을 다시 Set으로 변환
                if (state && Array.isArray(state.dismissedAlertIds)) {
                    state.dismissedAlertIds = new Set(state.dismissedAlertIds)
                }
            }
        }
    )
)
